export class ItemBySubcategory{
    itemSubCategoryId: number;
    constructor(
        itemSubCategoryId: number,
    ) {
        this.itemSubCategoryId = itemSubCategoryId;
    }
}